

$(function(){

	init_videos();

  setup_sr();

  setup_blinds_text();

	do_tilt()

  setup_smartplay_videos()


})


function setup_blinds_text(){
  setup_viz_watcher();
}


function do_tilt(){
	if (get_query_variable("tilt") == "true"){
		set_cookie("lol_tilt",true,30);

		$("html").addClass("tilt")
	}
  if (get_query_variable("tilt") == "false"){
		set_cookie("lol_tilt",false,30);
	}
	if (get_cookie("lol_tilt") == "true") {
		$("html").addClass("tilt")
	}
}



function setup_sr(){
	//auto-scrollreveal reveal stuff


  	$(".reveal").each(function(index,element){
      var delay = $(element).attr("data-delay") || 0;
      var direction = $(element).attr("data-direction") || "bottom"
      var duration = $(element).attr("data-duration") || 600
      var distance = $(element).attr("data-distance") || "18px"
      var reset = $(element).attr("data-reset") || false
      var scale = $(element).attr("data-scale") || 1

      var options = {
        distance: distance,
        origin: direction,
        duration: duration,
        delay: delay,
        viewFactor: 0.3,
        opacity:0,
        reset:reset,
        scale: scale,
        easing: 'ease-out'
      }
      ScrollReveal().reveal(element, options)
    })



    $("*[reveal]").each(function(index,element){
      var delay = $(element).attr("data-delay") || 0;
      var direction = $(element).attr("data-direction") || "bottom"
      var duration = $(element).attr("data-duration") || 600
      var distance = $(element).attr("data-distance") || "18px"
      var reset = $(element).attr("data-reset") || false
      var scale = $(element).attr("data-scale") || 1

      var options = {
        distance: distance,
        origin: direction,
        duration: duration,
        delay: delay,
        viewFactor: 0.3,
        opacity:0,
        reset:reset,
        scale: scale,
        easing: 'ease-out'
      }
      ScrollReveal().reveal(element, options)
    })
}




function calculate_customer_price(price, type, terms){
  	return (price / 100.0).toFixed(2)
}


function init_videos(){
  //for some reason, barba prevents the autoplay of bg videos. this fixes that.
  $(".bg-video video").each(function(i,e){

    var video = $(e).get(0)
    video.addEventListener("canplay", function(){
    	$(this).addClass("loaded")
        $(this).closest(".bg-video").addClass("loaded")
        $(this).get(0).play()
    });


  })
}

async function wait(ms){
  return new Promise(function(resolve){
    setTimeout(function(){resolve()}, ms)
  })
}



















//get a query variable by name
//super userful! no touchy!
function get_query_variable(name){
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


function set_query_variable(key, value) {
  var uri = window.location.href;
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    var new_url = uri.replace(re, '$1' + key + "=" + value + '$2');
    history.replaceState ({path:new_url}, null, new_url);
  }
  else {
    var new_url = uri + separator + key + "=" + value;
    history.replaceState ({path:new_url}, null, new_url);
  }
}


function remove_query_variable(sParam){
  var url = window.location.href.split('?')[0]+'?';
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] != sParam) {
          url = url + sParameterName[0] + '=' + sParameterName[1] + '&'
      }
  }

  var new_url = url.substring(0,url.length-1);
  history.replaceState ({path:new_url}, null, new_url);
}



//for animating svgs
function pathPrepare (e) {
  var lineLength = e.getTotalLength();
  $(e).css("stroke-dasharray", lineLength);
  $(e).css("stroke-dashoffset", lineLength);
}






function set_cookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function get_cookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function erase_cookie(name) {
    document.cookie = name+'=; Max-Age=-99999999;';
}

function setup_viz_watcher(threshold) {

  if (!threshold) threshold = 0.3

  window.obz_callbacks = {}

  window.obz = new IntersectionObserver(function(els) {

    for (var el of els) {
      if (el.isIntersecting === true) {
        $(el.target).addClass("visible")
        
        if (window.obz_callbacks[el.target.id])
          window.obz_callbacks[el.target.id](el.target)
      }
      else {
        $(el.target).removeClass("visible")
      }
    }


  }, {
    threshold: threshold
  });

  

  $("*[watch-visibility]").each(function(index, element) {
    window.obz.observe(element);
  })

}
function watch_it(el, callback) { //viz watcher but with a custom callback and custom element
  window.obz.observe(el);
  window.obz_callbacks[el.id] = callback
}

function setup_smartplay_videos(){
  var videos_to_smartplay = document.querySelectorAll("video[play-on-visible]")

  for (var video of videos_to_smartplay){
    if (!video.id) {
      console.log("Skipping video smartplay- video has no ID")
      continue;
    }
    watch_it(video, function(el){
      el.play()
    })

  }
}


$(function(){

  //smooth scrolly
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {

          var this_href = this.getAttribute('href')
          if (!this_href.includes("#") || this_href == "#") return


          e.preventDefault();

          
          var this_href = this.getAttribute('href')

          if (this_href == "#show-chat"){
            if (window.GorgiasChat) {
              window.GorgiasChat.open();
            } else {
              console.warn("Gorgias Chat not loaded yet.");
            }
          }
          else {
            document.querySelector(this_href).scrollIntoView({
              behavior: 'smooth'
            });
          }


          
      });
  });

})
